import React from "react";
import { Toolbar } from "react-admin";

const ProfileShowToolbar = (props) => (
    <Toolbar {...props} />
);

export default ProfileShowToolbar;
